<template>
  <v-dialog
    v-model="dialogOpen"
    max-width="400"
    @click:outside="close"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>Likes</span>
        <v-btn
          icon
          @click="close"
        >
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-list v-if="likers.length">
          <v-list-item
            v-for="(liker, idx) in likers"
            :key="`liker-${idx}`"
            class="liker-item"
            @click="goToProfile(liker.username)"
          >
            <v-list-item-avatar>
              <v-img :src="getAvatarUrl(liker.avatar)"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ liker.name }}</v-list-item-title>
              <v-list-item-subtitle v-if="liker.username">
                @{{ liker.username }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div
          v-else-if="loading"
          class="text-center pa-6"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div
          v-else
          class="text-center pa-6 text--secondary"
        >
          No likes yet.
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mdiClose } from '@mdi/js'

export default {
  name: 'LikersDialog',
  props: {
    fileId: {
      type: [Number, String],
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiClose,
      likers: [],
      loading: false,
      endpoint: process.env.VUE_APP_ROOT_API,
      defaultAvatar: require('@/assets/images/avatars/1.png'),
    }
  },
  computed: {
    dialogOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(open) {
      if (open && this.fileId) {
        this.fetchLikers()
      }
    },
  },
  methods: {
    getAvatarUrl(avatar) {
      if (avatar) {
        return `https://self-biography-system.s3.us-east-2.amazonaws.com/${avatar}`
      }

      return this.defaultAvatar
    },
    async fetchLikers() {
      this.loading = true
      this.likers = []
      try {
        const response = await axios.get(`${this.endpoint}/getLikes?file_id=${this.fileId}`)
        if (response.data && response.data.likers) {
          this.likers = response.data.likers
        }
      } catch {
        // Silently fail
      }
      this.loading = false
    },
    goToProfile(username) {
      if (username) {
        this.close()
        this.$router.push({ name: 'public_user', params: { username } })
      }
    },
    close() {
      this.dialogOpen = false
    },
  },
}
</script>

<style scoped lang="scss">
.liker-item {
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
}
</style>
